import { render } from "./Q4Simple.vue?vue&type=template&id=3b20b7fe"
import script from "./Q4Simple.vue?vue&type=script&lang=js"
export * from "./Q4Simple.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__